export const EXPERIMENT_NAME_AND_URL_CONTENT_REGEX = '^(?!-)[a-z0-9-]+(?<!-)$';
